<template>
  <div class="playVideo-layout">
    <div class="videoBox">
      <video controls="controls" preload="auto" webkit-playsinline="" playsinline="" x-webkit-airplay="allow"
        x5-playsinline="true" :poster="form.cover_path" class="video" :src="form.live_link"></video>
    </div>
  </div>
</template>

<script>
import hlsjs from "hls.js";
export default {
  props: ['form', 'meeting_data'],
  name: "About",
  components: {},
  data() {
    return {
      timer: null,
      endTime: "",
      VideoForm: {},
      videoType: "",
    };
  },
  created() {

  },
  mounted() {
    this.VideoForm = this.form
  },
};
</script>

<style lang="less" scoped>
.video {
  background-color: black;
  width: 100%;
  height: 56.7vw;
  max-width: 768px;
  max-height: 436px;
}

.pofBox {
  position: fixed !important;
  top: 0;
  max-width: 1200px;
  z-index: 999;
}
.playBack,
.playbox,
.pofBox {
  width: 100%;
  height: 56.7vw;
  background-color: black;
  max-width: 768px;
  max-height: 436px;
  position: relative;
}
.txt {
  color: #fff;
  width: 100%;
  line-height: 42px;
  position: absolute;
  bottom: 0;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.4));
  // background-color: rgba(0, 0, 0, 0.3);
  text-align: center;
  font-size: 18px;
}
.other {
  color: #fff;
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  margin: auto;
  text-align: center;
  transform: translateY(-50%);
}
.videoBox {
  overflow: hidden;
  width: 100%;
  height: 56.7vw;
  background-color: black;
  max-width: 768px;
  max-height: 436px;
}
.video_play_btn {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
}
</style>